interface FilterOption {
  value: string;
  label: string;
}

interface AdminFilterTabsProps {
  options: FilterOption[];
  value: string;
  onChange: (value: string) => void;
}

export default function AdminFilterTabs({ options, value, onChange }: AdminFilterTabsProps) {
  return (
    <div className="inline-flex flex-wrap items-center gap-1 rounded-full border border-background-300 bg-background-50 p-1 w-fit">
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          onClick={() => onChange(o.value)}
          className={`rounded-full px-3.5 py-1.5 text-sm font-semibold capitalize transition-colors whitespace-nowrap cursor-pointer ${
            value === o.value ? "bg-primary-500 text-foreground-950" : "text-foreground-600 hover:bg-background-100"
          }`}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}